import { useState } from "react";
import { T, ddmon } from "../clientsTokens";
import { Card, CardHead, Secondary, Dash } from "./recordBits";
import { RunbookModal } from "../../RunbookModal";

/* §24 — operational reference. Credentials are never rendered.

   Both actions open the runbook over this record rather than navigating to the
   runbooks page: reading a server name or remote-access detail is something you
   do while working on the client, and leaving the record to do it loses your
   place. */
export const RunbookCard = ({ clientId, companyName, runbook, loading }) => {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const show = (edit) => { setEditing(edit); setOpen(true); };
  const msp = runbook?.msp_provider;
  const mspText = typeof msp === "object" && msp
    ? [msp.name, msp.contact || msp.contact_name].filter(Boolean).join(" - ")
    : msp;
  const remote = runbook?.remote_access_type;
  const rows = [
    { label: "Server", value: typeof runbook?.server === "object" ? runbook?.server?.name : runbook?.server, mono: true },
    { label: "Remote access", value: typeof remote === "object" ? remote?.type || remote?.name : remote, mono: true },
    { label: "File location", value: runbook?.file_location, mono: true },
    { label: "MSP provider", value: mspText, mono: false },
    { label: "Last reviewed", value: ddmon(runbook?.updated_at), mono: true },
  ];
  const reviewed = runbook?.updated_at
    ? `Reviewed ${ddmon(runbook.updated_at)}${runbook.updated_by ? ` by ${runbook.updated_by}` : ""}`
    : "Never reviewed.";

  return (
    <Card testid="client-runbook">
      <CardHead title="Runbook" note="Access details for support and upgrades."
        action={<Secondary onClick={() => show(true)} testid="runbook-edit">Edit</Secondary>} />
      {loading ? (
        <div className="px-4 py-6 animate-pulse"><div className="h-3 rounded" style={{ width: "50%", background: T.sunken }} /></div>
      ) : rows.map((r) => (
        <div key={r.label} className="grid px-4 py-2.5 items-start"
          style={{ gridTemplateColumns: "150px minmax(0,1fr)", columnGap: 14, borderBottom: `1px solid ${T.dividerRow}` }}>
          <div className="text-[10.5px] font-bold uppercase" style={{ letterSpacing: "0.1em", color: T.muted }}>{r.label}</div>
          <div className={r.mono ? "mono text-[12px]" : "text-[12.5px]"}
            style={{ color: T.ink, wordBreak: r.mono ? "break-all" : "normal" }}>
            {r.value || <Dash />}
          </div>
        </div>
      ))}
      <div className="flex items-center gap-3 px-4 py-2.5" style={{ background: T.panel, borderTop: `1px solid ${T.dividerInner}` }}>
        <span className="text-[11.5px]" style={{ color: T.ink2 }}>{reviewed}</span>
        <button onClick={() => show(false)} className="ml-auto text-[12px] font-semibold underline"
          style={{ color: T.accentInk }} data-testid="runbook-full">View full runbook</button>
      </div>
      <RunbookModal open={open} onOpenChange={setOpen} clientId={clientId}
        company={companyName || runbook?.company_name || clientId} startInEdit={editing} />
    </Card>
  );
};
